import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
  Container,
  HeroContainer,
  InfoContainer,
  AvatarContainer,
  CustomAvatar,
  AvatarOverlay,
  EditIconWrapper
} from './styled'

import { Fab, Avatar } from '@mui/material'
import { styled } from '@mui/material/styles'
import { uploadProfileImage } from 'api'
import noAvatar from 'assets/images/no-avatar-upload.png'
import noBackground from 'assets/images/coworking.jpg'
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate'
import EditIcon from '@mui/icons-material/Edit'



const ProfileHeader = ({ avatar, background, onUpdate, setLoading }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedBackground, setSelectedBackground] = useState(null);
  const [theAvatar, setAvatar] = useState(avatar || noAvatar);
  const [theBackground, setBackground] = useState(background || noBackground);
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    if (avatar) {
      setAvatar(avatar);
    }
  }, [avatar]);

  useEffect(() => {
    if (background) {
      setBackground(background);
    }
  }, [background]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => setAvatar(e.target.result);
      reader.readAsDataURL(file);
      setSelectedFile(file);
    }
  };

  const handleBackgroundChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => setBackground(e.target.result);
      reader.readAsDataURL(file);
      setSelectedBackground(file);
    }
  };

  const handleUpload = async (type) => {
    try {
      setLoading(true);
      const file = type === 'avatar' ? selectedFile : selectedBackground;
      const response = await uploadProfileImage(type, file);
      if (response && response.status === 200) {
        if (type === 'avatar') {
          setSelectedFile(null);
        } else {
          setSelectedBackground(null);
        }
        onUpdate();
      } else {
        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
  };

  const openFileInput = () => {
    document.getElementById('avatarInput').click();
  };

  const openBackgroundInput = () => {
    document.getElementById('backgroundInput').click();
  };

  useEffect(() => {
    if (selectedFile !== null) {
      handleUpload('avatar')
    }
  }, [selectedFile])

  useEffect(() => {
    if (selectedBackground !== null) {
      handleUpload('background')
    }
  }, [selectedBackground])

  return (
    <Container>
      <HeroContainer elevation={0} background={theBackground}>
        <Fab
          color="primary"
          aria-label="add"
          onClick={openBackgroundInput}
          style={{
            position: 'absolute',
            bottom: 16,
            right: 16,
          }}
        >
          <AddPhotoAlternateIcon />
        </Fab>

        {/* Use a custom avatar component instead of StyledAvatar */}
        <CustomAvatar
          alt="User Avatar"
          src={theAvatar}
          onClick={openFileInput}
          onMouseEnter={() => setShowOverlay(true)}
          onMouseLeave={() => setShowOverlay(false)}
        />

        {/* Overlay with edit icon */}
        <AvatarOverlay className={showOverlay ? 'show' : ''}>
          <EditIconWrapper>
            <EditIcon sx={{ color: 'white', fontSize: '1.5rem' }} />
          </EditIconWrapper>
        </AvatarOverlay>
      </HeroContainer>

      <InfoContainer>
        <AvatarContainer>
          <input
            accept="image/*"
            style={{ display: 'none' }}
            id="avatarInput"
            type="file"
            onChange={handleFileChange}
          />
          <input
            accept="image/*"
            style={{ display: 'none' }}
            id="backgroundInput"
            type="file"
            onChange={handleBackgroundChange}
          />
        </AvatarContainer>
      </InfoContainer>
    </Container>
  )
}

ProfileHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  avatar: PropTypes.string,
  background: PropTypes.string,
  actionTitle: PropTypes.string,
  actionMethod: PropTypes.func,
  showAction: PropTypes.bool
}

export default ProfileHeader